export default __webpack_public_path__ + "static/media/erdos-cube-logo.9ecc62b6.png";